export default __webpack_public_path__ + "static/media/history.b94a160a.svg";